module.exports = __webpack_public_path__ + "img/public/SiteIcons/textCopyIcon.svg?0940c496";